/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfoSW: {
        id: 'quoteandbind.PSWProLinedirectives.templates.Remove Property',
        defaultMessage: 'Remove Property',
    },
    removeInfoDescSW: {
        id: 'quoteandbind.PSWProLinedirectives.templates.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Property from the list?',
    }
});